import { Component, inject, OnInit } from "@angular/core";
import { LayoutService } from "@core/services/layout.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.page.html',
  styleUrls: ['./terms-and-conditions.page.scss']
})
export class TermsAndConditionsPage implements OnInit {
  private readonly layoutService = inject(LayoutService);
  private readonly languageService = inject(TranslateService);

  ngOnInit(): void {
    this._setupLayout();
  }

  private _setupLayout(): void {
    this.layoutService.updateHeaderConfig({ ...this.layoutService.headerConfig$(), useHeader: true, useLogoutButton: false, useBackButton: false });
  }

  get currentLange(): string {
    return this.languageService.currentLang;
  }
}
